

// import React, { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import logo from "../../assets/synectiks-main-logo.svg";
// import "../styles/Navbar.css";

// const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const navRef = useRef(null);

//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//   };

//   const toggleDropdown = (name) => {
//     setActiveDropdown((prev) => (prev === name ? null : name));
//   };

//   const handleLinkClick = (path) => {
//     setMenuOpen(false);
//     setActiveDropdown(null);
//   };

//   useEffect(() => {
//     if (menuOpen) {
//       document.body.classList.add("menu-open");
//     } else {
//       document.body.classList.remove("menu-open");
//     }
//   }, [menuOpen]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (navRef.current && !navRef.current.contains(event.target)) {
//         setMenuOpen(false);
//         setActiveDropdown(null);
//       }
//     };

//     const handleResize = () => {
//       if (window.innerWidth > 992) {
//         setMenuOpen(false);
//         setActiveDropdown(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     window.addEventListener("resize", handleResize);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <nav
//       ref={navRef}
//       className="navbar"
//       role="navigation"
//       aria-label="Main navigation"
//     >
//       <div className="container">
//         <div className="logo">
//           <Link
//             to="/"
//             onClick={() => handleLinkClick("/")}
//             aria-label="Synectiks homepage"
//           >
//             <img src={logo} alt="Synectiks Logo" />
//           </Link>
//         </div>
//         <button
//           className="hamburger"
//           onClick={toggleMenu}
//           aria-label="Toggle navigation menu"
//           aria-expanded={menuOpen}
//         >
//           <div className={`line ${menuOpen ? "active" : ""}`}></div>
//           <div className={`line ${menuOpen ? "active" : ""}`}></div>
//           <div className={`line ${menuOpen ? "active" : ""}`}></div>
//         </button>
//         <ul
//           className={`nav-links ${menuOpen ? "active" : ""}`}
//           role="menubar"
//         >
//           <li role="none">
//             <Link
//               to="/home"
//               onClick={() => handleLinkClick("/home")}
//               role="menuitem"
//             >
//               Home
//             </Link>
//           </li>

//           {/* Services Dropdown */}
//           <li
//             className={`dropdown dropdown-services ${activeDropdown === "services" ? "active" : ""
//               }`}
//             role="none"
//           >
//             <button
//               type="button"
//               className="nav-button"
//               aria-expanded={activeDropdown === "services"}
//               onClick={() => toggleDropdown("services")}
//             >
//               Services
//               <span className="dropdown-chevron" aria-hidden="true">
//                 ⌵
//               </span>
//             </button>
//             <div
//               className={`dropdown-content services-dropdown ${activeDropdown === "services" ? "show" : ""
//                 }`}
//               role="menu"
//             >
//               {/* RENAMED GRID CLASS */}
//               <div className="navbar-services-grid">
//                 {/* RENAMED COLUMN CLASS */}
//                 <div className="navbar-services-column">
//                   <section className="service-category">
//                     <div className="service-icon" aria-hidden="true">
//                       🔧
//                     </div>
//                     <div className="category-text">
//                       <h4>Our Services</h4>
//                       <p>
//                         We provide comprehensive IT services that keep your business
//                         secure, resilient, and efficient.
//                       </p>
//                     </div>
//                   </section>
//                   <section className="contact-section">
//                     <Link
//                       to="/company/contact"
//                       onClick={() => handleLinkClick("/company/contact")}
//                       role="menuitem"
//                     >
//                       <h4>Contact Us</h4>
//                     </Link>
//                   </section>
//                 </div>
//                 {/* RENAMED COLUMN CLASS */}
//                 <div className="navbar-services-column">
//                   <Link
//                     to="/services/endpoint"
//                     onClick={() => handleLinkClick("/services/endpoint")}
//                     role="menuitem"
//                   >
//                     Endpoint Management & Security
//                   </Link>
//                   <Link
//                     to="/services/backup"
//                     onClick={() => handleLinkClick("/services/backup")}
//                     role="menuitem"
//                   >
//                     Backup
//                   </Link>
//                   <Link
//                     to="/services/disaster"
//                     onClick={() => handleLinkClick("/services/disaster")}
//                     role="menuitem"
//                   >
//                     Disaster Recovery
//                   </Link>
//                   <Link
//                     to="/services/vdi"
//                     onClick={() => handleLinkClick("/services/vdi")}
//                     role="menuitem"
//                   >
//                     Virtual Desktops
//                   </Link>
//                   <Link
//                     to="/services/infrastructure"
//                     onClick={() => handleLinkClick("/services/infrastructure")}
//                     role="menuitem"
//                   >
//                     Secure Cloud Hosting
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </li>

//           {/* Modern Workplace Dropdown */}
//           <li
//             className={`dropdown dropdown-workplace ${activeDropdown === "workplace" ? "active" : ""}`}
//             role="none"
//           >
//             <button
//               type="button"
//               onClick={(e) => {
//                 e.preventDefault();
//                 e.stopPropagation();
//                 toggleDropdown("workplace");
//               }}
//               className="nav-button"
//               aria-expanded={activeDropdown === "workplace"}
//             >
//               Modern Workplace
//               <span className="dropdown-chevron" aria-hidden="true">⌵</span>
//             </button>
//             <div className={`dropdown-content services-dropdown ${activeDropdown === "workplace" ? "show" : ""}`} role="menu">
//               {/* RENAMED GRID CLASS */}
//               <div className="navbar-services-grid">
//                 {/* RENAMED COLUMN CLASS */}
//                 <div className="navbar-services-column">
//                   <section className="service-category">
//                     <div className="service-icon" aria-hidden="true">💼</div>
//                     <div className="category-text">
//                       <h4>Modern Workplace</h4>
//                       <p>Transform your workplace with modern collaboration tools.</p>
//                     </div>
//                   </section>
//                   <section className="contact-section">
//                     <Link to="/company/contact" onClick={() => handleLinkClick("/company/contact")}>
//                       <h4>Contact Us</h4>
//                     </Link>
//                   </section>
//                 </div>
//                 {/* RENAMED COLUMN CLASS */}
//                 <div className="navbar-services-column">
//                   <Link to="/workplace/microsoft-365" onClick={() => handleLinkClick("/workplace/microsoft-365")}>Microsoft 365</Link>
//                   <Link to="/workplace/copilot" onClick={() => handleLinkClick("/workplace/copilot")}>Copilot Integration</Link>
//                 </div>
//               </div>
//             </div>
//           </li>

//           {/* Solutions Dropdown */}
//           <li
//             className={`dropdown dropdown-solutions ${activeDropdown === "solutions" ? "active" : ""}`}
//             role="none"
//           >
//             <button
//               type="button"
//               onClick={(e) => {
//                 e.preventDefault();
//                 e.stopPropagation();
//                 toggleDropdown("solutions");
//               }}
//               className="nav-button"
//               aria-expanded={activeDropdown === "solutions"}
//             >
//               Solutions
//               <span className="dropdown-chevron" aria-hidden="true">⌵</span>
//             </button>
//             <div className={`dropdown-content services-dropdown ${activeDropdown === "solutions" ? "show" : ""}`} role="menu">
//               {/* RENAMED GRID CLASS */}
//               <div className="navbar-services-grid">
//                 {/* RENAMED COLUMN CLASS */}
//                 <div className="navbar-services-column">
//                   <section className="service-category">
//                     <div className="service-icon" aria-hidden="true">💡</div>
//                     <div className="category-text">
//                       <h4>Our Solutions</h4>
//                       <p>Comprehensive technology solutions designed to accelerate your digital transformation.</p>
//                     </div>
//                   </section>
//                   <section className="contact-section">
//                     <Link to="/company/contact" onClick={() => handleLinkClick("/company/contact")}>
//                       <h4>Contact Us</h4>
//                     </Link>
//                   </section>
//                 </div>
//                 {/* RENAMED COLUMN CLASS */}
//                 <div className="navbar-services-column">
//                   <Link to="/solutions/application-development" onClick={() => handleLinkClick("/solutions/application-development")}>Application Development</Link>
//                   <Link to="/solutions/cloud-adoption" onClick={() => handleLinkClick("/solutions/cloud-adoption")}>Cloud Adoption & Migration</Link>
//                 </div>
//               </div>
//             </div>
//           </li>

//           {/* Company Dropdown (Standard) */}
//           <li className="dropdown dropdown-company" role="none">
//             <button
//               type="button"
//               onClick={(e) => {
//                 e.preventDefault();
//                 e.stopPropagation();
//                 toggleDropdown("company");
//               }}
//               className="nav-button"
//               role="menuitem"
//               aria-haspopup="true"
//               aria-expanded={activeDropdown === "company"}
//             >
//               Company
//               <span className="dropdown-chevron" aria-hidden="true">
//                 ⌵
//               </span>
//             </button>
//             <div
//               className={`dropdown-content ${activeDropdown === "company" ? "show" : ""
//                 }`}
//               role="menu"
//             >
//               <Link
//                 to="/company/about"
//                 onClick={() => handleLinkClick("/company/about")}
//                 role="menuitem"
//               >
//                 About Us
//               </Link>
//               <Link
//                 to="/company/careers"
//                 onClick={() => handleLinkClick("/company/careers")}
//                 role="menuitem"
//               >
//                 Careers
//               </Link>
//             </div>
//           </li>
//           <li>
//             <button
//               className="custom-contact-button"
//               onClick={() => (window.location.href = "/company/contact")}
//             >
//               Contact Us
//             </button>
//           </li>
//         </ul>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;










import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom"; // Import useLocation
import logo from "../../assets/synectiks-main-logo.svg";
import "../styles/Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navRef = useRef(null);
  const location = useLocation(); // Get current URL
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDropdown = (name) => {
    setActiveDropdown((prev) => (prev === name ? null : name));
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
    setActiveDropdown(null);
  };

  // --- Helper: Check if a path is active ---
  // Returns true if the current location matches the link
  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [menuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
        setActiveDropdown(null);
      }
    };

    const handleResize = () => {
      if (window.innerWidth > 992) {
        setMenuOpen(false);
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <nav
      ref={navRef}
      className="navbar"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="container">
        <div className="logo">
          <Link to="/" onClick={handleLinkClick} aria-label="Synectiks homepage">
            <img src={logo} alt="Synectiks Logo" />
          </Link>
        </div>
        <button
          className="hamburger"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <div className={`line ${menuOpen ? "active" : ""}`}></div>
          <div className={`line ${menuOpen ? "active" : ""}`}></div>
          <div className={`line ${menuOpen ? "active" : ""}`}></div>
        </button>

        <ul className={`nav-links ${menuOpen ? "active" : ""}`} role="menubar">

          {/* HOME LINK */}
          {/* <li role="none">
            <Link
              to="/"
              onClick={handleLinkClick}
              role="menuitem"
              // Add 'active-link' class if current path is /home
              className={isActive("/") ? "active-link" : ""}
            >
              Home
            </Link>
          </li> */}
          <li role="none">
            <Link
              to="/"
              onClick={handleLinkClick}
              role="menuitem"
              // Pass 'true' here to ensure it ONLY highlights when the path is exactly "/"
              className={isActive("/", true) ? "active-link" : ""}
            >
              Home
            </Link>
          </li>

          {/* SERVICES DROPDOWN */}
          <li
            className={`dropdown dropdown-services ${activeDropdown === "services" ? "active" : ""}`}
            role="none"
          >
            <button
              type="button"
              // Add 'active-link' if ANY /services/ page is open
              className={`nav-button ${isActive("/services") ? "active-link" : ""}`}
              aria-expanded={activeDropdown === "services"}
              onClick={() => toggleDropdown("services")}
            >
              Services
              <span className="dropdown-chevron" aria-hidden="true">⌵</span>
            </button>
            <div className={`dropdown-content services-dropdown ${activeDropdown === "services" ? "show" : ""}`} role="menu">
              <div className="navbar-services-grid">
                <div className="navbar-services-column">
                  <section className="service-category">
                    <div className="service-icon" aria-hidden="true">🔧</div>
                    <div className="category-text">
                      <h4>Our Services</h4>
                      <p>We provide comprehensive IT services that keep your business secure, resilient, and efficient.</p>
                    </div>
                  </section>
                  <section className="contact-section">
                    <Link to="/company/contact" onClick={handleLinkClick}>
                      <h4>Contact Us</h4>
                    </Link>
                  </section>
                </div>
                <div className="navbar-services-column">
                  {/* Individual Links: Highlight if exact match */}
                  <Link to="/services/endpoint" onClick={handleLinkClick} className={isActive("/services/endpoint", true) ? "active-item" : ""}>
                    Endpoint Management & Security
                  </Link>
                  <Link to="/services/backup" onClick={handleLinkClick} className={isActive("/services/backup", true) ? "active-item" : ""}>
                    Backup
                  </Link>
                  <Link to="/services/disaster" onClick={handleLinkClick} className={isActive("/services/disaster", true) ? "active-item" : ""}>
                    Disaster Recovery
                  </Link>
                  <Link to="/services/daas" onClick={handleLinkClick} className={isActive("/services/daas", true) ? "active-item" : ""}>
                    Desktop as a Service
                  </Link>
                  <Link to="/services/infrastructure" onClick={handleLinkClick} className={isActive("/services/infrastructure", true) ? "active-item" : ""}>
                    Secure Cloud Hosting
                  </Link>
                </div>
              </div>
            </div>
          </li>

          {/* MODERN WORKPLACE DROPDOWN */}
          <li
            className={`dropdown dropdown-workplace ${activeDropdown === "workplace" ? "active" : ""}`}
            role="none"
          >
            <button
              type="button"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown("workplace"); }}
              className={`nav-button ${isActive("/workplace") ? "active-link" : ""}`}
              aria-expanded={activeDropdown === "workplace"}
            >
              Modern Workplace
              <span className="dropdown-chevron" aria-hidden="true">⌵</span>
            </button>
            <div className={`dropdown-content services-dropdown ${activeDropdown === "workplace" ? "show" : ""}`} role="menu">
              <div className="navbar-services-grid">
                <div className="navbar-services-column">
                  <section className="service-category">
                    <div className="service-icon" aria-hidden="true">💼</div>
                    <div className="category-text">
                      <h4>Modern Workplace</h4>
                      <p>Transform your workplace with modern collaboration tools.</p>
                    </div>
                  </section>
                  <section className="contact-section">
                    <Link to="/company/contact" onClick={handleLinkClick}>
                      <h4>Contact Us</h4>
                    </Link>
                  </section>
                </div>
                <div className="navbar-services-column">
                  <Link to="/workplace/microsoft-365" onClick={handleLinkClick} className={isActive("/workplace/microsoft-365", true) ? "active-item" : ""}>
                    Microsoft 365
                  </Link>
                  <Link to="/workplace/copilot" onClick={handleLinkClick} className={isActive("/workplace/copilot", true) ? "active-item" : ""}>
                    Copilot Integration
                  </Link>
                </div>
              </div>
            </div>
          </li>

          {/* SOLUTIONS DROPDOWN */}
          <li
            className={`dropdown dropdown-solutions ${activeDropdown === "solutions" ? "active" : ""}`}
            role="none"
          >
            <button
              type="button"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown("solutions"); }}
              className={`nav-button ${isActive("/solutions") ? "active-link" : ""}`}
              aria-expanded={activeDropdown === "solutions"}
            >
              Solutions
              <span className="dropdown-chevron" aria-hidden="true">⌵</span>
            </button>
            <div className={`dropdown-content services-dropdown ${activeDropdown === "solutions" ? "show" : ""}`} role="menu">
              <div className="navbar-services-grid">
                <div className="navbar-services-column">
                  <section className="service-category">
                    <div className="service-icon" aria-hidden="true">💡</div>
                    <div className="category-text">
                      <h4>Our Solutions</h4>
                      <p>Comprehensive technology solutions designed to accelerate your digital transformation.</p>
                    </div>
                  </section>
                  <section className="contact-section">
                    <Link to="/company/contact" onClick={handleLinkClick}>
                      <h4>Contact Us</h4>
                    </Link>
                  </section>
                </div>
                <div className="navbar-services-column">
                  <Link to="/solutions/application-development" onClick={handleLinkClick} className={isActive("/solutions/application-development", true) ? "active-item" : ""}>
                    Application Development
                  </Link>
                  <Link to="/solutions/cloud-adoption" onClick={handleLinkClick} className={isActive("/solutions/cloud-adoption", true) ? "active-item" : ""}>
                    Cloud Adoption & Migration
                  </Link>
                </div>
              </div>
            </div>
          </li>

          {/* COMPANY DROPDOWN */}
          <li className="dropdown dropdown-company" role="none">
            <button
              type="button"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown("company"); }}
              className={`nav-button ${isActive("/company") ? "active-link" : ""}`}
              role="menuitem"
              aria-haspopup="true"
              aria-expanded={activeDropdown === "company"}
            >
              Company
              <span className="dropdown-chevron" aria-hidden="true">⌵</span>
            </button>
            <div className={`dropdown-content ${activeDropdown === "company" ? "show" : ""}`} role="menu">
              <Link to="/company/about" onClick={handleLinkClick} className={isActive("/company/about", true) ? "active-item" : ""}>
                About Us
              </Link>
              <Link to="/company/careers" onClick={handleLinkClick} className={isActive("/company/careers", true) ? "active-item" : ""}>
                Careers
              </Link>
            </div>
          </li>

          <li>
            <button
              className="custom-contact-button"
              // onClick={() => (window.location.href = "/company/contact")}
              // onClick={() => navigate("/company/contact")}
              onClick={() => {
                handleLinkClick(); // Close the mobile menu if open
                navigate("/company/contact"); // Navigate without page reload
              }}
            >
              Contact Us
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;